import {normalize} from 'normalizr';

import api from '../../api';
import {schema} from '../../schema';
import {addEntities} from '../../actions';
import Logger from '../../../lib/Logger';

// ACTION TYPES

export const PARTNERSHIP_LIST_REQUEST = 'PARTNERSHIP_LIST_REQUEST';
export const PARTNERSHIP_LIST_SUCCESS = 'PARTNERSHIP_LIST_SUCCESS';
export const PARTNERSHIP_LIST_FAILURE = 'PARTNERSHIP_LIST_FAILURE';

// ACTION CREATORS

export function partnershipListRequest(page, limit, order, filter) {
  Logger.log('debug', `[partnerships.actions] partnershipListRequest(${page}, ${limit}, ${order}, %j)`, filter);
  return {
    type: PARTNERSHIP_LIST_REQUEST,
    page: page,
    limit: limit,
    order: order,
    filter: filter
  }
}

export function partnershipListSuccess(data) {
  Logger.log('debug', `[partnerships.actions] partnershipListSuccess(%j)`, data);
  return {
    type: PARTNERSHIP_LIST_SUCCESS,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now()
  }
}

export function partnershipListFailure(error) {
  Logger.log('debug', `[partnerships.actions] partnershipListFailure(%j)`, error);
  return {
    type: PARTNERSHIP_LIST_FAILURE,
    error: error
  }
}


// API THUNK ACTION CREATORS

export function loadPartnerships(page=1, limit=10, order=null, filter=null, cb=function(){}) {
  Logger.log('debug', `[partnership.actions] loadPartnerships(${page}, ${limit}, ${order}, %j, ###)`, filter);

  return async function(dispatch) {
    dispatch(partnershipListRequest(page, limit, order, filter));

    // call API
    const response = await api.getPartnerships(page, limit, order, filter);
    let success = false;

    // get partnerships list success
    if (200 === response.get('status')) {

      Logger.log('info', `Get API partnerships list success. Page: ${page}, Limit: ${limit}, Order: ${order}.`);

      const normalizedEntities = normalize(response.getIn(['data', 'partnerships']), [schema.partnership]);
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(partnershipListSuccess(data));
      success = true;

    } else if (1 === page && 204 === response.get('status')) {

      Logger.log('info', `Get API partnerships success [empty]. Page: ${page}, Limit: ${limit}, Order: ${order}.`);
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: []
      };
      dispatch(partnershipListSuccess(data));
      success = true;
      
    // get partnerships list failure
    } else {
      Logger.log('info', `Get API partnerships list failure. Page: ${page}, Limit: ${limit}, Order: ${order}.`);
      dispatch(partnershipListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  }
}


Logger.log('silly', `partnerships.actions loaded.`);
